import { useCallback } from 'react';

import { apiFactory } from '@app/client/ApiFactory';
import { registerEmptyUser } from '@app/client/resources/users.ts';
import { addNotification } from '@app/store/actions/notification';
import { setUserPartnerAddresses } from '@app/store/actions/partner-integrations';
import { initializeUser } from '@app/store/actions/user';
import { useAuthTokens, UserType } from '@app/store/zustand';

import { useTokens } from '../authentication/useTokens.ts';
import { useAppDispatch } from '../redux/useAppDispatch.ts';
import { useAppSelector } from '../redux/useAppSelector.ts';

export function useDraftUser() {
    const dispatch = useAppDispatch();

    const isAuthenticated = useAuthTokens((state) => !!state.token.access_token);
    const { setTokens } = useTokens();

    const partnerConversionId = useAppSelector((rootState) => rootState.partnerIntegrations.partnerConversionId);
    const walletAddresses = useAppSelector((rootState) => rootState.partnerIntegrations.walletAddresses);

    return useCallback(async () => {
        if (!isAuthenticated) {
            const registerDraftUser = await apiFactory().call(registerEmptyUser, {
                value: { partner_conversion_id: partnerConversionId },
            });

            if (registerDraftUser.ok) {
                await setTokens(registerDraftUser.value, UserType.Draft);
                await initializeUser();
                if (walletAddresses) {
                    dispatch(setUserPartnerAddresses(walletAddresses));
                }
                return;
            } else {
                dispatch(addNotification({ message: registerDraftUser.error as string, severity: 'error' }));
            }
        }
    }, [dispatch, isAuthenticated, partnerConversionId, setTokens, walletAddresses]);
}
